import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { authService } from '../services/auth.service';

const UserValidation = () => {
  const location = useLocation();
  const { isAuthenticated } = useAuth();

  useEffect(() => {
    const validateUser = async () => {
      if (isAuthenticated && location.pathname !== '/login') {
        try {
          // Check if session is valid
          await authService.getProfile({ skipAuthRedirect: false });
        } catch {
          // If 401, it will be handled by interceptor, but we can also logout here
          // Interceptor redirects to login usually
        }
      }
    };

    validateUser();
  }, [location.pathname, isAuthenticated]);

  return null;
};

export default UserValidation;
